import { render, staticRenderFns } from "./SustainabilitySettings.vue?vue&type=template&id=3a30fcb8&scoped=true&"
import script from "./SustainabilitySettings.vue?vue&type=script&lang=js&"
export * from "./SustainabilitySettings.vue?vue&type=script&lang=js&"
import style0 from "./SustainabilitySettings.vue?vue&type=style&index=0&id=3a30fcb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30fcb8",
  null
  
)

export default component.exports